// Shared media constants
// Default cover image for user cards when no cover is uploaded
// Use non-empty SVG to avoid empty JPG fallback warnings
// Add a version query to bust CDN caches when refreshed
// Use API-served asset so subdomain rewrites don't break the image request
export const DEFAULT_COVER = '/api/assets/default-cover.svg?v=20251104';

// Branded default covers for Free plan users (safe, cache-busted URLs served by API)
// If any image fails at runtime, UI falls back to REMOTE_FALLBACK_COVER_URL via onError handlers.
export const BRANDED_COVERS: string[] = [
	'/api/assets/default-cover.svg?v=20251104',
	'/api/assets/default-cover-2.svg?v=20251104',
	'/api/assets/default-cover-3.svg?v=20251104',
];
